import Script from 'next/script'
import { useSelector } from 'react-redux'

import { useEffect, useRef } from 'react'

import useIsConsentGroupEnabled from 'hooks/useIsConsentGroupEnabled'
import { Screen } from 'constants/tracking/screens'
import { getScreenName } from 'state/screen/selectors'
import { ConsentGroup } from 'constants/consent'

const Rokt = () => {
  const resolveRef = useRef<(value: void | PromiseLike<void>) => void>()
  const screenName = useSelector(getScreenName)

  const hasConsentedTargeting = useIsConsentGroupEnabled(ConsentGroup.Targeting)
  const hasConsentedPersonalisedAds = useIsConsentGroupEnabled(ConsentGroup.PersonalisedAds)

  const isInInbox = [
    Screen.ConversationList,
    Screen.ConversationNew,
    Screen.ConversationReply,
  ].includes(screenName)

  const isScriptAvailable = isInInbox && hasConsentedTargeting && hasConsentedPersonalisedAds

  function getRoktLauncher() {
    return window.Rokt.createLauncher({
      accountId: '3105142925732150316',
    })
  }

  function onRoktLoad() {
    resolveRef.current?.(getRoktLauncher())
  }

  useEffect(() => {
    if (!isScriptAvailable) return

    window.RoktLauncher = new Promise<void>(resolve => {
      resolveRef.current = resolve

      if (!window.Rokt) return

      resolve(getRoktLauncher())
    })
  }, [isScriptAvailable])

  if (!isScriptAvailable) return null

  return (
    <Script
      crossOrigin="anonymous"
      id="rokt-launcher"
      src="https://apps.rokt.com/wsdk/integrations/launcher.js"
      strategy="lazyOnload"
      onLoad={onRoktLoad}
    />
  )
}

export default Rokt
